import {
  FETCH_BY_TEMPLATE_ID__ERROR,
  FETCH_BY_TEMPLATE_ID__REQUEST,
  FETCH_BY_TEMPLATE_ID__SUCCESS,
} from "../../actionTypes";
import { TemplateMetadataByIdSTORE, TemplatesActions } from "../../types";

import templateReducer from "./singleTemplate";

const initialState: TemplateMetadataByIdSTORE = {};

const byId = (
  state = initialState,
  action: TemplatesActions
): TemplateMetadataByIdSTORE => {
  switch (action.type) {
    case FETCH_BY_TEMPLATE_ID__ERROR:
    case FETCH_BY_TEMPLATE_ID__REQUEST:
    case FETCH_BY_TEMPLATE_ID__SUCCESS:
      // tenhle lint problem zmizí s ts immer
      // eslint-disable-next-line
      const templateId = action.payload.id;
      return {
        ...state,
        [templateId]: templateReducer(state[templateId], action),
      };

    default:
      return state;
  }
};

export default byId;
